(function() {
  'use strict';

  // ========================
  // CONSTANTS
  // ========================
  var API_BASE = 'https://api.autosyncstudio.com';
  var API_KEY = 'qsOlUVFb8npKN1OdJ2J7';
  var WHEEL_IMG = 'https://wheels.autosyncstudio.com/png/';
  var TIRE_IMG = 'https://storage.googleapis.com/autosync_tires/';

  // ========================
  // BRAND SITES MAP (Clearbit logo fallback)
  // ========================
  var BRAND_SITES = {
    "DFC": "dynamicfriction.com",
    "Covercraft": "covercraft.com",
    "R1 Concepts": "r1concepts.com",
    "PowerStop": "powerstop.com",
    "EBC": "ebcbrakes.com",
    "Cometic Gasket": "cometic.com",
    "Rough Country": "roughcountry.com",
    "Brembo": "brembo.com",
    "Bilstein": "bilstein.com",
    "AP Exhaust Products": "apemissions.com",
    "AP Exhaust": "apemissions.com",
    "Gates": "gates.com",
    "Fel-Pro": "felpro.com",
    "Fuel Wheels": "fueloffroad.com",
    "Moog": "moogparts.com",
    "Rugged Ridge": "ruggedridge.com",
    "Eagle": "eaglerod.com",
    "COMP Cams": "compcams.com",
    "Fabtech": "fabtechmotorsports.com",
    "Victor Reinz": "victorreinz.com",
    "Skyjacker Suspension": "skyjacker.com",
    "Goodridge": "goodridge.com",
    "Wilwood": "wilwood.com",
    "Skyjacker": "skyjacker.com",
    "QA1": "qa1.net",
    "Weld": "weldwheels.com",
    "Oracle Lighting": "oraclelights.com",
    "Yukon Gear & Axle": "yukongear.com",
    "MGP": "calipercovers.com",
    "ARP": "arp-bolts.com",
    "Metra Electronics": "metraonline.com",
    "Spyder Auto": "spyderauto.com",
    "Energy Suspension": "energysuspensionparts.com",
    "JE Pistons": "jepistons.com",
    "Crown Automotive": "crownauto.com",
    "Manley Performance": "manleyperformance.com",
    "Icon Vehicle Dynamics": "iconvehicledynamics.com",
    "Vossen": "vossenwheels.com",
    "Zone Offroad": "zoneoffroad.com",
    "Fox Shocks": "ridefox.com",
    "ACL": "aclraceseries.com",
    "KYB": "kyb.com",
    "Brembo OE": "brembo.com",
    "King Engine Bearings": "kingbearings.com",
    "Eibach": "eibach.com",
    "Ferrea": "ferrea.com",
    "aFe": "afepower.com",
    "DBA": "dbausa.com",
    "Husky Liners": "huskyliners.com",
    "HushMat": "hushmat.com",
    "aFe Power": "afepower.com",
    "MagnaFlow": "magnaflow.com",
    "Curt Manufacturing": "curtmfg.com",
    "SPEC": "specclutch.com",
    "Action Clutch": "actionclutch.com",
    "SPARCO": "sparco-official.com",
    "Fragola": "fragola.com",
    "Advan": "advan.com",
    "Putco": "putco.com",
    "Diode Dynamics": "diodedynamics.com",
    "Rock Krawler": "rockkrawler.com",
    "H&R": "hrsprings.com",
    "Race Sport": "racesportinc.com",
    "Ironman 4x4": "ironman4x4.com",
    "Prothane": "prothane.com",
    "BDS Suspension": "bds-suspension.com",
    "Mishimoto": "mishimoto.com",
    "Supertech": "supertechperformance.com",
    "Go Rhino": "gorhino.com",
    "Superpro": "superpro-suspension.com",
    "Magnaflow": "magnaflow.com",
    "Different Trends": "dtexhaust.com",
    "Hawk Performance": "hawkperformance.com",
    "Enkei": "enkei.com",
    "Blue Ox": "blueox.com",
    "K&N": "knfilters.com",
    "3D MAXpider": "3dmaxpider.com",
    "Clutch Masters": "clutchmasters.com",
    "Raceline": "racelinewheels.com",
    "Clevite": "clevite.com",
    "Westin": "westinautomotive.com",
    "King Shocks": "kingshocks.com",
    "AutoMeter": "autometer.com",
    "Belltech": "belltech.com",
    "Ridetech": "ridetech.com",
    "ACT": "advancedclutch.com",
    "ARB": "arbusa.com",
    "BBS": "bbs.com",
    "TeraFlex": "teraflex.com",
    "ARB / Old Man Emu": "arbusa.com",
    "Auto Ventshade": "autoventshade.com",
    "Superlift": "superlift.com",
    "Wehrli": "wcfab.com",
    "Access Cover": "agricover.com",
    "CP Pistons": "cp-carrillo.com",
    "HKS": "hksusa.com",
    "BFGoodrich": "bfgoodrichtires.com",
    "Warn": "warn.com",
    "Tein": "tein.com",
    "Draw-Tite": "drawtite.com",
    "Baja Designs": "bajadesigns.com",
    "Remus": "remus.eu",
    "OMP": "ompracing.com",
    "Flowmaster": "flowmaster.com",
    "KW": "kwsuspensions.com",
    "Holley": "holley.com",
    "Anzo": "anzousa.com",
    "Whiteline": "whitelineperformance.com",
    "Method Race Wheels": "methodracewheels.com",
    "Torque Solution": "torquesolution.com",
    "Stoptech": "stoptech.com",
    "StopTech": "stoptech.com",
    "FOX": "ridefox.com",
    "Nitrous Express": "nitrousexpress.com",
    "NRG": "nrginnovations.com",
    "Moroso": "moroso.com",
    "Dakota Digital": "dakotadigital.com",
    "Edelbrock": "edelbrock.com",
    "DeatschWerks": "deatschwerks.com",
    "Vision X": "visionxusa.com",
    "KMC": "kmcwheels.com",
    "do88": "do88.global",
    "UnderCover": "undercoverinfo.com",
    "XD Series": "xdwheels.com",
    "Fab Fours": "fabfours.com",
    "Hella": "hella.com",
    "BMC": "bmcairfilters.com",
    "Advance Adapters": "advanceadapters.com",
    "Morimoto": "morimotohid.com",
    "Exedy": "exedy.com",
    "BMR Suspension": "bmrsuspension.com",
    "Borla": "borla.com",
    "Turbosmart": "turbosmart.com",
    "Maxtrac": "maxtracsuspension.com",
    "Stampede": "stampedeproducts.com",
    "Toyo Tires": "toyotires.com",
    "GReddy": "greddy.com",
    "Buyers Products": "buyersproducts.com",
    "Lund": "lundtrucks.com",
    "RTX": "rtxwheels.com",
    "Injen": "injen.com",
    "Rugged Radios": "ruggedradios.com",
    "Mahle": "mahle.com",
    "Timbren": "timbren.com",
    "Pace Edwards": "paceedwards.com",
    "UMI Performance": "umiperformance.com",
    "Steelcraft": "steelcraftautomotive.com",
    "Moto Metal": "motometal.com",
    "XCLUTCH": "xclutch.com",
    "COBB": "cobbtuning.com",
    "Stainless Works": "stainlessworks.net",
    "AMP Research": "amp-research.com",
    "MBRP": "mbrp.com",
    "Vibrant": "vibrantperformance.com",
    "JW Speaker": "jwspeaker.com",
    "Yokohama Tire": "yokohamatire.com",
    "Radflo": "radfloshocks.com",
    "Aries": "ariesautomotive.com",
    "Rhino-Rack": "rhinorack.com",
    "DS18": "ds18.com",
    "PRP Seats": "prpseats.com",
    "Brian Crower": "briancrower.com",
    "Gibson": "gibsonperformance.com",
    "KONI": "koni-na.com",
    "Borla Exhaust": "borla.com",
    "NGK": "ngksparkplugs.com",
    "Rancho": "gorancho.com",
    "Recon": "reconaccessories.com",
    "K&N Engineering": "knfilters.com",
    "Tuff Country": "tuffcountry.com",
    "Black Rhino": "blackrhinowheels.com",
    "Dynomax Performance Exhaust": "dynomax.com",
    "Konig": "konigwheels.com",
    "McLeod Racing": "mcleodracing.com",
    "BLOX Racing": "bloxracing.com",
    "Carli": "carlisuspension.com",
    "MBRP Inc.": "mbrp.com",
    "Cali Raised LED": "caliraisedled.com",
    "Corsa": "corsaperformance.com",
    "N-Fab": "n-fab.com",
    "Seibon": "seibon.com",
    "Rally Armor": "rallyarmor.com",
    "MSD": "msdignition.com",
    "Artec Industries": "artecindustries.com",
    "Banks Power": "bankspower.com",
    "Akrapovic": "akrapovic.com",
    "Industrial Injection": "industrialinjection.com",
    "Bestop": "bestop.com",
    "AWE Tuning": "awe-tuning.com",
    "Dee Zee": "deezee.com",
    "BD Diesel": "bddiesel.com",
    "Perrin Performance": "perrin.com",
    "Air Lift": "airliftcompany.com",
    "Mickey Thompson": "mickeythompsontires.com",
    "Hellwig Products": "hellwigproducts.com",
    "Pro Comp Wheels": "procompusa.com",
    "Luverne": "luvernetruckequipment.com",
    "Belltech (KW Automotive)": "belltech.com",
    "Ridetech Suspension": "ridetech.com",
    "Auto Ventshade (AVS)": "autoventshade.com",
    "ARB Usa/Old Man Emu": "arbusa.com",
    "Driveshaft Shop": "driveshaftshop.com",
    "Stainless Bros": "stainlessbros.com",
    "Camburg": "camburg.com",
    "Race Star": "racestarwheels.com",
    "Aeromotive": "aeromotiveinc.com",
    "SPC Performance": "spcperformance.com",
    "TruXedo": "truxedo.com",
    "Skunk2 Racing": "skunk2.com",
    "AlphaRex": "alpharexusa.com",
    "Corsa Exhaust": "corsaperformance.com",
    "Falken": "falkentire.com",
    "JKS Manufacturing": "jksmfg.com",
    "ReadyLift": "readylift.com",
    "Bushwacker": "bushwacker.com",
    "Garrett": "garrettmotion.com",
    "Air Lift Company": "airliftcompany.com",
    "HornBlasters": "hornblasters.com",
    "Frontier Truck Gear": "frontiertruck.com",
    "Hellwig": "hellwigproducts.com",
    "Extang": "extang.com",
    "Road Armor": "roadarmor.com",
    "Fleece Performance": "fleeceperformance.com",
    "BAK Industries": "bakindustries.com",
    "DV8 Offroad": "dv8offroad.com",
    "Haltech": "haltech.com",
    "Rigid Industries": "rigidindustries.com",
    "Rancho Suspensions": "gorancho.com",
    "Kooks Headers": "kooksheaders.com",
    "CSF": "csfrace.com",
    "Smittybilt": "smittybilt.com",
    "Retrax": "retrax.com",
    "Synergy Mfg": "synergymfg.com",
    "Ohlins": "ohlins.com",
    "Michelin": "michelinman.com",
    "Competition Clutch": "competitionclutch.com",
    "Addictive Desert Designs": "addictivedesertdesigns.com",
    "Injector Dynamics": "injectordynamics.com",
    "Airaid": "airaid.com",
    "BedRug": "bedrug.com",
    "Forgestar": "forgestar.com",
    "KC HiLiTES": "kchilites.com",
    "Daystar International": "daystarweb.com",
    "Old Man Emu": "arbusa.com",
    "Dynojet": "dynojet.com",
    "Daystar": "daystarweb.com",
    "Roll-N-Lock": "rollnlock.com",
    "Ranch Hand": "ranchhand.com",
    "Eaton": "eaton.com",
    "Chemical Guys": "chemicalguys.com",
    "BackRack": "backrack.com",
    "BBK": "bbkperformance.com",
    "ORACLE Lighting": "oraclelights.com",
    "Volant": "volant.com",
    "Body Armor 4x4": "bodyarmor4x4.com",
    "Hotchkis": "hotchkis.net",
    "REDARC": "redarcelectronics.com",
    "CORSA Performance": "corsaperformance.com",
    "Motul": "motul.com",
    "Cerwin Vega": "cerwinvega.com",
    "Roush": "roushperformance.com",
    "Koyo": "koyorad.com",
    "GrimmSpeed": "grimmspeed.com",
    "BBK Performance": "bbkperformance.com",
    "Fluidampr": "fluidampr.com",
    "HP Tuners": "hptuners.com",
    "Antigravity Batteries": "antigravitybatteries.com",
    "Lokar": "lokar.com",
    "LIQUI MOLY": "liqui-moly.com",
    "Recaro": "recaro-automotive.com",
    "SPAL": "spalusa.com",
    "Titan Fuel Tanks": "titanfueltanks.com",
    "Superwinch": "superwinch.com",
    "Royal Purple": "royalpurple.com",
    "WeatherTech": "weathertech.com",
    "T-Rex Grilles": "t-rex-products.com",
    "SCT Performance": "sctflash.com",
    "Factor 55": "factor55.com",
    "Front Runner Outfitters": "frontrunneroutfitters.com",
    "DiabloSport": "diablosport.com",
    "Fishbone Offroad": "fishboneoffroad.com",
    "Sinister Diesel": "sinisterdiesel.com",
    "MOMO": "momo.com",
    "Dirty Life": "dirtylifewheels.com",
    "Rampage": "rampageproducts.com",
    "Fidanza": "fidanza.com",
    "RockJock": "rockjock4x4.com",
    "OMIX": "omix-ada.com",
    "fifteen52": "fifteen52.com",
    "Fuelab": "fuelab.com",
    "XS Power": "xspower.com",
    "McGard": "mcgard.com",
    "Spectre": "spectreperformance.com",
    "Dynamat": "dynamat.com",
    "Cognito": "cognitomotorsports.com",
    "RS-R": "rs-r.com",
    "Hurst": "hurstshifters.com",
    "K1 Technologies": "k1technologies.com",
    "Hedman Hedders": "hedman.com",
    "ION Wheels": "ionwheels.com",
    "Mayhem": "mayhemwheels.com",
    "Touren": "tourenwheels.com",
    "Ridler Wheels": "ridlerwheels.com",
    "American Truxx": "americantruxx.com",
    "Rival 4x4": "rival4x4.com",
    "Nacho Offroad Technology": "nachooffroad.com",
    "BOSS Audio": "bossaudio.com",
    "Nankang": "nankang.com",
    "Exergy": "exergyperformance.com",
    "AST": "ast-suspension.com",
    "Rhino USA": "rhinousa.com",
    "Sundown Audio": "sundownaudio.com",
    "Massive Audio": "massiveaudio.com",
    "Weigh Safe": "weighsafe.com",
    "Kentrol / Fishbone": "fishboneoffroad.com",
    "Kentrol/Fishbone Offroad": "fishboneoffroad.com",
    "B & W Trailer Hitches": "bwtrailerhitches.com",
    "B&W Trailer Hitches": "bwtrailerhitches.com",
    "Tonno Pro": "tonnopro.com",
    "Bulldog Winch": "bulldogwinch.com",
    "ReadyLift Suspension / Logiq Air": "readylift.com",
    "Clevite Engine Parts": "clevite.com",
    "Westin Automotive": "westinautomotive.com",
    "Fox Factory": "ridefox.com",
    "Bosch": "bosch.com",
    "CTEK": "ctek.com",
    "Hi-Lift Jack": "hi-lift.com",
    "GEN-Y Hitch": "genyhitch.com",
    "Wheel Mate": "wheelmate.com",
    "Griots Garage": "griotsgarage.com",
    "ICON": "iconvehicledynamics.com",
    "DU-HA": "du-ha.com",
    "Savvy Off-Road": "savvyoffroad.com",
    "EGR": "egrusa.com",
    "Cali Off-Road": "calioffroad.com",
    "Cali Offroad": "calioffroad.com",
    "Black Widow Exhaust": "blackwidowexhaust.com",
    "CrawlTek Revolution": "crawltekrevolution.com",
    "BorgWarner": "borgwarner.com",
    "Raxiom": "raxiom.com",
    "Mile Marker": "milemarker.com",
    "MagnaFlow Exhaust Systems": "magnaflow.com",
    "Advance Adapters Inc": "advanceadapters.com",
    "Husky Liner": "huskyliners.com",
    "Auto Meter": "autometer.com",
    "ARP Inc.": "arp-bolts.com",
    "ICI/Innovative Creations Inc.": "icionline.com",
    "Maxtrac Suspension": "maxtracsuspension.com",
    "Access Bed Covers": "agricover.com",
    "Access": "agricover.com",
    "Anzo Usa": "anzousa.com",
    "ANZO": "anzousa.com",
    "Luverne Truck Equipment": "luvernetruckequipment.com",
    "Truxedo": "truxedo.com",
    "BAK": "bakindustries.com",
    "Amp Research": "amp-research.com",
    "Undercover": "undercoverinfo.com",
    "LUND": "lundtrucks.com",
    "Fel-Pro Oe": "felpro.com",
    "Manley": "manleyperformance.com",
    "Hedman": "hedman.com",
    "Pro Comp": "procompusa.com",
    "Boss Audio": "bossaudio.com",
    "BD Diesel Performance": "bddiesel.com",
    "Covercraft Industries LLC": "covercraft.com",
    "Bestop Inc.": "bestop.com",
    "Rampage Products": "rampageproducts.com",
    "Lund International": "lundtrucks.com",
    "Mishimoto / Borne Off Road": "mishimoto.com",
    "SPYDER": "spyderauto.com",
    "Spyder Automotive": "spyderauto.com",
    "K&N Filters": "knfilters.com",
    "AVS": "autoventshade.com",
    "QA1 Precision Products Inc": "qa1.net",
    "Superchips": "superchips.com",
    "Rugged Liner": "ruggedliner.com",
    "Fia Inc.": "fiainc.com",
    "Odyssey Battery": "odysseybattery.com",
    "RDS": "rdsaluminum.com",
    "Gorilla Automotive": "gorilla-auto.com",
    "Red Line": "redlineoil.com",
    "Chase Bays": "chasebays.com",
    "Hopkins Manufacturing": "hopkinsmfg.com",
    "GiroDisc": "girodisc.com",
    "XKGLOW": "xkglow.com",
    "Racequip": "racequip.com",
    "ISC Suspension": "iscsuspension.com",
    "ISR Performance": "isrperformance.com",
    "Atturo Tire": "atturotire.com",
    "Hypertech": "hypertech.com",
    "Pypes": "pypesexhaust.com",
    "Rywire": "rywire.com",
    "Anderson Composites": "andersoncomposites.com",
    "ATS Diesel": "atsdiesel.com",
    "SSR": "ssr-wheels.com",
    "Ticon": "ticonindustries.com",
    "Wagner Tuning": "wagnertuning.com",
    "Alcon": "alcon.co.uk",
    "SLP": "slpperformance.com",
    "Doug's Headers": "holley.com",
    "Mr. Gasket Co.": "holley.com",
    "Weiand": "holley.com",
    "Flowtech": "holley.com",
    "Lakewood": "holley.com",
    "Hooker": "holley.com",
    "Roadmaster Inc": "roadmasterinc.com",
    "Torklift": "torklift.com",
    "Torklift International": "torklift.com",
    "Demco": "demco-products.com",
    "Stinger": "stingerdrive.com",
    "Snow Performance": "snowperformance.net",
    "Maxtrax": "maxtrax.com.au",
    "FAST": "fuelairspark.com",
    "Rock Jock": "rockjock4x4.com",
    "Weapon R": "weaponr.com",
    "Bell": "bellhelmets.com",
    "Radium Engineering": "radiumauto.com",
    "Innovative Mounts": "innovative-mounts.com",
    "Diamond Eye Performance": "diamondeyeperformance.com",
    "Revolution Gear & Axle": "revolutiongear.com",
    "Borne Off-Road": "borneoffroad.com",
    "Kentrol": "kentrolinc.com",
    "Race Sport Lighting": "racesportinc.com",
    "Steelcraft Automotive": "steelcraftautomotive.com",
    "TOYO": "toyotires.com",
    "Method Wheels": "methodracewheels.com",
    "Dynomax": "dynomax.com",
    "JBA": "jbaheaders.com",
    "JBA Performance Exhaust": "jbaheaders.com",
    "Invidia": "invidia-exhausts.com",
    "Bubba Rope": "bubbarope.com",
    "DKM Clutch": "dkmclutch.com",
    "Trans-Dapt": "tdperformance.com",
    "Proform": "proformparts.com",
    "Dart": "dartheads.com",
    "Pioneer": "pioneerelectronics.com",
    "Firestone": "firestoneairide.com",
    "Tensor Tire": "tensortire.com",
    "Morryde": "morryde.com",
    "Smarty": "smartyperformance.com",
    "Viair Corporation": "viair.com",
    "Rock Tamers LLC": "rocktamers.com",
    "AirDog": "pureflow.com",
    "TURN Offroad": "turnoffroad.com",
    "Agency Power": "agencypower.com",
    "mountune": "mountuneusa.com",
    "Vivid Racing": "vividracing.com",
    "Go Industries": "goindustries.com",
    "Battery Tender": "batterytender.com",
    "AEM": "aemelectronics.com",
    "AEM Induction": "aemintakes.com",
    "Vance and Hines": "vanceandhines.com",
    "DEI": "designengineering.com",
    "Kansei": "kanseiwheels.com",
    "MB Quart": "mbquart.com",
    "KraftWerks": "kraftwerksusa.com",
    "Pop N Lock": "popnlock.com",
    "Tuffy": "tuffyproducts.com",
    "Nomad": "nomadwheels.com",
    "AudioControl": "audiocontrol.com",
    "Planet Audio": "planetaudio.com",
    "Hifonics": "hifonics.com",
    "Directed Electronics": "directedelectronics.com",
    "Sound Storm": "soundstormind.com",
    "AMP Tires": "ampoffroad.com",
    "Brandmotion": "brandmotion.com",
    "Power Acoustik": "poweracoustik.com",
    "SoundStream": "soundstream.com",
    "Rydeen": "rydeenusa.com",
    "Bolt Lock": "boltlock.com",
    "Unique Truck Accessories": "uniquetruckaccessories.com",
    "Competition Engineering": "holley.com",
    "Progressive Industries": "progressiveindustries.net",
    "Tazer": "tazerbytc.com",
    "ProMaxx Automotive": "promaxxautomotive.com",
    "Recon Truck Accessories": "reconaccessories.com",
    "Monster Hooks Inc": "monsterhooks.com",
    "Voodoo Offroad": "voodoooffroad.com",
    "Yokohama": "yokohamatire.com",
    "Nitto": "nittotire.com",
    "Cooper": "coopertire.com",
    "Continental": "continentaltire.com",
    "Bridgestone": "bridgestonetire.com",
    "Goodyear": "goodyear.com",
    "Hankook": "hankooktire.com",
    "Pirelli": "pirelli.com"
  };

  // ========================
  // HELPERS
  // ========================
  function $(id) { return document.getElementById(id); }

  function esc(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function brandLogoUrl(name) {
    return 'https://storage.googleapis.com/autosync-brand-logos/logos/' + name.replace(/ /g, '_') + '.webp';
  }

  function brandSiteUrl(name) {
    if (BRAND_SITES[name]) return BRAND_SITES[name];
    return name.toLowerCase().replace(/[^a-z0-9]/g, '') + '.com';
  }

  function clearbitUrl(name) {
    var site = brandSiteUrl(name);
    return site ? 'https://logo.clearbit.com/' + site + '?size=160' : '';
  }

  function extractBrands(data) {
    return ((data.Filters || data).Brands || []).map(function(b) {
      return typeof b === 'string' ? b : b.Brand || b.Name || String(b);
    });
  }

  // ========================
  // API
  // ========================
  function api(endpoint, params, cb) {
    params = params || {};
    var qs = 'key=' + encodeURIComponent(API_KEY);
    Object.keys(params).forEach(function(k) {
      if (params[k] !== '' && params[k] != null) {
        qs += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
      }
    });
    fetch(API_BASE + '/' + endpoint + '?' + qs)
      .then(function(r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
      .then(function(d) { cb(null, d); })
      .catch(function(e) { cb(e, null); });
  }

  // ========================
  // INIT
  // ========================
  function init() {
    var root = document.querySelector('.afw-bg');
    if (!root) return;

    var productType = root.getAttribute('data-product-type') || 'wheels';
    var isWheels = productType === 'wheels';
    var isAll = productType === 'all';
    var activeType = isWheels ? 'wheels' : 'tires';
    var brandTypeMap = {};

    // State
    var brands = [];
    var filterOptions = {};
    var alphaFilter = 'all';
    var searchMode = null;
    var selectedVehicle = null;
    var sizeFilters = {};
    var level = 'brands';
    var currentBrand = null;
    var models = [];
    var modelOffset = 0;
    var modelMore = false;
    var configs = [];
    var configOffset = 0;
    var configMore = false;
    var activeStyleId = null;
    var activeModelId = null;
    var activeModelName = '';
    var savedScrollY = 0;
    var wheelImgBase = WHEEL_IMG;
    var tireImgBase = TIRE_IMG;

    // DOM refs
    var elGrid = $('afw-bg-grid');
    var elLoading = $('afw-bg-loading');
    var elEmpty = $('afw-bg-empty');
    var elAlpha = $('afw-bg-alpha');
    var elSearch = $('afw-bg-search');
    var elCount = $('afw-bg-count');
    var elResults = $('afw-bg-results');
    var elResultsName = $('afw-bg-results-name');
    var elResultsCount = $('afw-bg-results-count');
    var elResultsLogo = $('afw-bg-results-logo');
    var elBack = $('afw-bg-back');
    var elProducts = $('afw-bg-products');
    var elProductsLoader = $('afw-bg-products-loader');
    var elMore = $('afw-bg-more');
    var elMoreBtn = $('afw-bg-more-btn');
    var elProductSearch = $('afw-bg-product-search');
    var elVehicleInput = $('afw-bg-vehicle-input');
    var elVehicleWrap = $('afw-bg-vehicle-search-wrap');
    var elVehicleResults = $('afw-bg-vehicle-results');
    var elVehicleSelected = $('afw-bg-vehicle-selected');
    var elVehicleInfo = $('afw-bg-vehicle-info');
    var elVehicleClear = $('afw-bg-vehicle-clear');
    var elFitBadge = $('afw-bg-fitment-badge');
    var elFitBadgeText = $('afw-bg-fitment-badge-text');
    var elFitBadgeClear = $('afw-bg-fitment-badge-clear');
    var elSizeFilters = $('afw-bg-size-filters');
    var elSizeBtn = $('afw-bg-size-btn');
    var elSizeClear = $('afw-bg-size-clear');
    var elBrandSelect = $('afw-bg-brand-select');
    var elLightbox = $('afw-bg-lightbox');
    var elLightboxImg = $('afw-bg-lightbox-img');
    var elLightboxInfo = $('afw-bg-lightbox-info');
    var elLightboxClose = $('afw-bg-lightbox-close');
    var elTypeToggle = $('afw-bg-type-toggle');

    var lbImages = [];
    var lbIndex = 0;

    // ========================
    // INITIAL LOAD
    // ========================
    elLoading.style.display = 'flex';

    if (isAll) {
      var pending = 2;
      var wheelBrands = [];
      var tireBrands = [];
      function allDone() {
        elLoading.style.display = 'none';
        wheelBrands.forEach(function(b) { brandTypeMap[b] = 'wheels'; });
        tireBrands.forEach(function(b) {
          brandTypeMap[b] = brandTypeMap[b] ? 'both' : 'tires';
        });
        var allSet = {};
        wheelBrands.forEach(function(b) { allSet[b] = true; });
        tireBrands.forEach(function(b) { allSet[b] = true; });
        if (window.__afwShopVendors) {
          window.__afwShopVendors.forEach(function(v) {
            if (!allSet[v]) { allSet[v] = true; brandTypeMap[v] = 'parts'; }
          });
        }
        brands = Object.keys(allSet).sort(function(a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
        if (brands.length === 0) {
          elEmpty.style.display = 'block';
          elEmpty.innerHTML = '<p>Unable to load brands. Please try again later.</p>';
          return;
        }
        if (elCount) elCount.textContent = brands.length + ' Brands';
        buildBrandGrid();
        buildAlphaButtons();
        populateBrandDropdown();
      }
      api('wheels/filters', { 'i-brands': true }, function(err, data) {
        if (!err && data) wheelBrands = extractBrands(data);
        if (--pending === 0) allDone();
      });
      api('tires/filters', { 'i-brands': true }, function(err, data) {
        if (!err && data) tireBrands = extractBrands(data);
        if (--pending === 0) allDone();
      });
    } else {
      var filterEndpoint = isWheels ? 'wheels/filters' : 'tires/filters';
      var filterParams = { 'i-brands': true };
      if (isWheels) {
        filterParams['i-diameters'] = true;
        filterParams['i-widths'] = true;
        filterParams['i-boltCircles'] = true;
        filterParams['i-lugCounts'] = true;
        filterParams['i-shortColors'] = true;
        filterParams['i-shortFinishes'] = true;
      } else {
        filterParams['i-diameters'] = true;
        filterParams['i-sectionWidths'] = true;
        filterParams['i-aspectRatios'] = true;
        filterParams['i-speedRatings'] = true;
        filterParams['i-tags'] = true;
      }
      api(filterEndpoint, filterParams, function(err, data) {
        elLoading.style.display = 'none';
        if (err || !data) {
          elEmpty.style.display = 'block';
          elEmpty.innerHTML = '<p>Unable to load brands. Please try again later.</p>';
          return;
        }
        var f = data.Filters || data;
        brands = extractBrands(data).sort(function(a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
        filterOptions = {
          diameters: f.Diameters || [],
          widths: f.Widths || [],
          boltCircles: f.BoltCircles || [],
          lugCounts: f.LugCounts || [],
          shortColors: f.ShortColors || [],
          shortFinishes: f.ShortFinishes || [],
          sectionWidths: f.SectionWidths || [],
          aspectRatios: f.AspectRatios || [],
          speedRatings: f.SpeedRatings || [],
          segmentTags: f.SegmentTags || [],
          vehicleTypeTags: f.VehicleTypeTags || []
        };
        if (elCount) elCount.textContent = brands.length + ' Brands';
        buildBrandGrid();
        buildAlphaButtons();
        buildSizeDropdowns();
        populateBrandDropdown();
      });
    }

    // ========================
    // BRAND GRID (Level 1)
    // ========================
    function buildBrandGrid() {
      elGrid.innerHTML = '';
      brands.forEach(function(name) {
        var letter = name.charAt(0).toUpperCase();
        if (/^\d/.test(letter)) letter = '#';
        var card = document.createElement('a');
        card.className = 'afw-bg__card';
        card.href = '#';
        card.setAttribute('data-brand', name.toLowerCase());
        card.setAttribute('data-letter', letter);
        card.setAttribute('data-vendor', name);
        var logo = brandLogoUrl(name);
        var cb = clearbitUrl(name);
        card.innerHTML =
          '<div class="afw-bg__logo-wrap">' +
            '<img src="' + logo + '" alt="' + esc(name) + '" loading="lazy" data-cb="' + cb + '"' +
            ' onerror="if(!this.dataset.tried&&this.dataset.cb){this.dataset.tried=1;this.src=this.dataset.cb;}else{this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\';}">' +
            '<div class="afw-bg__monogram" style="display:none">' + esc(name.charAt(0).toUpperCase()) + '</div>' +
          '</div>' +
          '<span class="afw-bg__name">' + esc(name) + '</span>';
        card.addEventListener('click', function(e) {
          e.preventDefault();
          clickBrand(name);
        });
        elGrid.appendChild(card);
      });
    }

    function buildAlphaButtons() {
      var letters = {};
      brands.forEach(function(b) {
        var l = b.charAt(0).toUpperCase();
        if (/^\d/.test(l)) l = '#';
        letters[l] = true;
      });
      Object.keys(letters).sort(function(a, b) {
        if (a === '#') return -1;
        if (b === '#') return 1;
        return a.localeCompare(b);
      }).forEach(function(l) {
        var btn = document.createElement('button');
        btn.className = 'afw-bg__alpha-btn';
        btn.setAttribute('data-letter', l);
        btn.textContent = l;
        elAlpha.appendChild(btn);
      });
    }

    function filterBrandGrid() {
      var q = elSearch.value.toLowerCase().trim();
      var cards = elGrid.querySelectorAll('.afw-bg__card');
      var visible = 0;
      cards.forEach(function(card) {
        var name = card.getAttribute('data-brand') || '';
        var letter = card.getAttribute('data-letter') || '';
        var show = true;
        if (q && name.indexOf(q) === -1) show = false;
        if (alphaFilter !== 'all' && letter !== alphaFilter) show = false;
        card.classList.toggle('is--hidden', !show);
        if (show) visible++;
      });
      elEmpty.style.display = visible === 0 ? 'block' : 'none';
      elGrid.style.display = visible === 0 ? 'none' : '';
    }

    // ========================
    // SIZE DROPDOWNS
    // ========================
    function buildSizeDropdowns() {
      if (!elSizeFilters) return;
      var html = '';
      if (isWheels) {
        if (filterOptions.diameters.length) html += makeSelect('afw-bg-sz-dia', 'Diameter', filterOptions.diameters, '"');
        if (filterOptions.widths.length) html += makeSelect('afw-bg-sz-width', 'Width', filterOptions.widths, '"');
        if (filterOptions.lugCounts.length) html += makeSelect('afw-bg-sz-lug', 'Lug Count', filterOptions.lugCounts, '');
        if (filterOptions.boltCircles.length) html += makeSelect('afw-bg-sz-bolt', 'Bolt Circle', filterOptions.boltCircles, 'mm');
        if (filterOptions.shortColors.length) html += makeSelect('afw-bg-sz-color', 'Color', filterOptions.shortColors, '');
        if (filterOptions.shortFinishes.length) html += makeSelect('afw-bg-sz-finish', 'Finish', filterOptions.shortFinishes, '');
      } else {
        if (filterOptions.diameters.length) html += makeSelect('afw-bg-sz-dia', 'Rim Diameter', filterOptions.diameters, '"');
        if (filterOptions.sectionWidths.length) html += makeSelect('afw-bg-sz-sw', 'Tire Width', filterOptions.sectionWidths, 'mm');
        if (filterOptions.aspectRatios.length) html += makeSelect('afw-bg-sz-ar', 'Aspect Ratio', filterOptions.aspectRatios, '');
        if (filterOptions.speedRatings.length) html += makeSelect('afw-bg-sz-speed', 'Speed Rating', filterOptions.speedRatings, '');
        if (filterOptions.segmentTags.length) html += makeSelect('afw-bg-sz-segment', 'Type', filterOptions.segmentTags, '');
        if (filterOptions.vehicleTypeTags.length) html += makeSelect('afw-bg-sz-vtype', 'Vehicle Type', filterOptions.vehicleTypeTags, '');
      }
      elSizeFilters.innerHTML = html;
      if (elSizeBtn) elSizeBtn.style.display = '';
      elSizeFilters.querySelectorAll('select').forEach(function(sel) {
        sel.addEventListener('change', onSizeChange);
      });
    }

    function makeSelect(id, label, options, suffix) {
      var h = '<div class="afw-bg__sz-field">';
      h += '<label for="' + id + '">' + label + '</label>';
      h += '<select id="' + id + '"><option value="">Any</option>';
      options.forEach(function(v) {
        h += '<option value="' + v + '">' + v + (suffix || '') + '</option>';
      });
      h += '</select></div>';
      return h;
    }

    function collectSizeFilters() {
      sizeFilters = {};
      var manDia = $('afw-bg-man-dia');
      var manWidth = $('afw-bg-man-width');
      var manLug = $('afw-bg-man-lug');
      var manBolt = $('afw-bg-man-bolt');
      var manRim = $('afw-bg-man-rim');
      var manSW = $('afw-bg-man-sw');
      var manAR = $('afw-bg-man-ar');

      if (manDia && manDia.value) sizeFilters.diameter = manDia.value;
      else { var d = $('afw-bg-sz-dia'); if (d && d.value) sizeFilters.diameter = d.value; }

      if (manWidth && manWidth.value) sizeFilters.width = manWidth.value;
      else { var w = $('afw-bg-sz-width'); if (w && w.value) sizeFilters.width = w.value; }

      if (manLug && manLug.value) sizeFilters.lugCount = manLug.value;
      else { var l = $('afw-bg-sz-lug'); if (l && l.value) sizeFilters.lugCount = l.value; }

      if (manBolt && manBolt.value) sizeFilters.boltCircle = manBolt.value;
      else { var b = $('afw-bg-sz-bolt'); if (b && b.value) sizeFilters.boltCircle = b.value; }

      var manOffset = $('afw-bg-man-offset');
      if (manOffset && manOffset.value) sizeFilters.offset = manOffset.value;

      if (manRim && manRim.value) sizeFilters.diameter = manRim.value;
      else if (!sizeFilters.diameter) { var rd = $('afw-bg-sz-dia'); if (rd && rd.value) sizeFilters.diameter = rd.value; }

      if (manSW && manSW.value) sizeFilters.sectionWidth = manSW.value;
      else { var sw = $('afw-bg-sz-sw'); if (sw && sw.value) sizeFilters.sectionWidth = sw.value; }

      if (manAR && manAR.value) sizeFilters.aspectRatio = manAR.value;
      else { var ar = $('afw-bg-sz-ar'); if (ar && ar.value) sizeFilters.aspectRatio = ar.value; }

      var color = $('afw-bg-sz-color'); if (color && color.value) sizeFilters.shortColor = color.value;
      var finish = $('afw-bg-sz-finish'); if (finish && finish.value) sizeFilters.shortFinish = finish.value;
      var speed = $('afw-bg-sz-speed'); if (speed && speed.value) sizeFilters.speedRating = speed.value;
      var seg = $('afw-bg-sz-segment'); if (seg && seg.value) sizeFilters.segmentTag = seg.value;
      var vtype = $('afw-bg-sz-vtype'); if (vtype && vtype.value) sizeFilters.vehicleTypeTag = vtype.value;
    }

    function onSizeChange() {
      collectSizeFilters();
      var hasAny = Object.keys(sizeFilters).some(function(k) { return sizeFilters[k]; });
      var hasBrand = getSelectedBrand();
      if (elSizeBtn) elSizeBtn.disabled = !(hasAny || hasBrand);
    }

    function bindManualInputs() {
      ['afw-bg-man-dia','afw-bg-man-width','afw-bg-man-lug','afw-bg-man-bolt','afw-bg-man-offset',
       'afw-bg-man-rim','afw-bg-man-sw','afw-bg-man-ar'].forEach(function(id) {
        var el = $(id);
        if (el) {
          el.addEventListener('input', onSizeChange);
          if (el.tagName === 'SELECT') el.addEventListener('change', onSizeChange);
        }
      });
    }

    function getSelectedBrand() {
      return elBrandSelect ? elBrandSelect.value : '';
    }

    function populateBrandDropdown() {
      if (!elBrandSelect) return;
      brands.forEach(function(b) {
        var opt = document.createElement('option');
        opt.value = b;
        opt.textContent = b;
        elBrandSelect.appendChild(opt);
      });
    }

    // ========================
    // CLICK BRAND -> Level 2 (Models)
    // ========================
    function clickBrand(name) {
      /* Always navigate to brand collection or search */
      window.location.href = '/search?type=product&q=vendor%3A%22' + encodeURIComponent(name) + '%22';
      return;
      if (isAll) {
        var type = brandTypeMap[name] || 'wheels';
        if (type === 'parts') {
          window.location.href = '/search?type=product&q=vendor%3A%22' + encodeURIComponent(name) + '%22';
          return;
        }
        activeType = type === 'tires' ? 'tires' : 'wheels';
      }
      currentBrand = name;
      searchMode = null;
      level = 'models';
      modelOffset = 0;
      modelMore = false;
      savedScrollY = window.scrollY;

      showResultsHeader(name, brandLogoUrl(name));
      elResultsCount.textContent = 'Loading...';

      if (elTypeToggle && isAll) {
        if (brandTypeMap[name] === 'both') {
          elTypeToggle.innerHTML =
            '<button class="afw-bg__toggle-btn' + (activeType === 'wheels' ? ' is--active' : '') + '" data-type="wheels"><i class="las la-circle"></i> Wheels</button>' +
            '<button class="afw-bg__toggle-btn' + (activeType === 'tires' ? ' is--active' : '') + '" data-type="tires"><i class="las la-dot-circle"></i> Tires</button>';
          elTypeToggle.style.display = 'flex';
        } else {
          elTypeToggle.style.display = 'none';
        }
      }

      showResults();
      loadModels(true);
    }

    // ========================
    // SIZE SEARCH -> Level 2
    // ========================
    function startSizeSearch() {
      collectSizeFilters();
      var hasFilters = Object.keys(sizeFilters).some(function(k) { return sizeFilters[k]; });
      var brand = getSelectedBrand();
      if (!hasFilters && !brand) return;

      searchMode = 'size';
      currentBrand = brand || null;
      level = 'models';
      modelOffset = 0;
      modelMore = false;
      savedScrollY = window.scrollY;

      var parts = [];
      if (brand) parts.push(brand);
      if (sizeFilters.diameter) parts.push(sizeFilters.diameter + '"');
      if (sizeFilters.width) parts.push(sizeFilters.width + '" wide');
      if (sizeFilters.lugCount) parts.push(sizeFilters.lugCount + '-lug');
      if (sizeFilters.boltCircle) parts.push(sizeFilters.boltCircle + 'mm');
      if (sizeFilters.offset) { var oLabels = {'neg-high':'Deep Lip','neg-low':'Negative','zero':'Zero','pos-low':'Low ET','pos-med':'Med ET','pos-high':'High ET','pos-xhigh':'XHigh ET'}; parts.push(oLabels[sizeFilters.offset] || sizeFilters.offset); }
      if (sizeFilters.sectionWidth) parts.push(sizeFilters.sectionWidth + 'mm width');
      if (sizeFilters.aspectRatio) parts.push('/' + sizeFilters.aspectRatio);
      if (sizeFilters.shortColor) parts.push(sizeFilters.shortColor);
      if (sizeFilters.shortFinish) parts.push(sizeFilters.shortFinish);
      var desc = parts.join(' \u00b7 ');

      if (brand) {
        showResultsHeader(brand, brandLogoUrl(brand));
      } else {
        var iw = isAll ? activeType === 'wheels' : isWheels;
        elResultsName.textContent = iw ? 'Wheels' : 'Tires';
        elResultsLogo.innerHTML = '<i class="las la-ruler-combined" style="font-size:32px;color:#CC0022"></i>';
      }
      elResultsCount.textContent = 'Loading...';

      if (elFitBadge && elFitBadgeText) {
        elFitBadgeText.textContent = desc;
        elFitBadge.style.display = 'flex';
      }
      if (elSizeClear) elSizeClear.style.display = '';

      showResults();
      loadModels(true);
    }

    // ========================
    // VEHICLE SEARCH -> Level 2
    // ========================
    function startVehicleSearch(vehicle) {
      selectedVehicle = vehicle;
      searchMode = 'vehicle';
      currentBrand = getSelectedBrand() || null;
      level = 'models';
      modelOffset = 0;
      modelMore = false;
      savedScrollY = window.scrollY;

      var vName = vehicle.Year + ' ' + vehicle.Make + ' ' + vehicle.Model;
      if (vehicle.Submodel) vName += ' ' + vehicle.Submodel;

      if (elVehicleInput) elVehicleInput.value = '';
      if (elVehicleResults) { elVehicleResults.innerHTML = ''; elVehicleResults.style.display = 'none'; }
      if (elVehicleSelected) {
        var html = '<div class="afw-bg__vi-name"><i class="las la-car"></i> ' + esc(vName) + '</div>';
        html += '<div class="afw-bg__vi-specs">';
        if (vehicle.LugCount && vehicle.BoltCircle) {
          html += '<div class="afw-bg__vi-spec"><span>Bolt Pattern</span><strong>' + vehicle.LugCount + 'x' + vehicle.BoltCircle + 'mm</strong></div>';
        }
        if (vehicle.Bore) {
          html += '<div class="afw-bg__vi-spec"><span>Center Bore</span><strong>' + vehicle.Bore + 'mm</strong></div>';
        }
        var fit = vehicle.Fitments && vehicle.Fitments[0];
        if (fit) {
          if (fit.TireSize) html += '<div class="afw-bg__vi-spec"><span>OE Tire</span><strong>' + esc(fit.TireSize) + '</strong></div>';
          if (fit.RimDiameter) html += '<div class="afw-bg__vi-spec"><span>OE Wheel</span><strong>' + fit.RimDiameter + '"</strong></div>';
        }
        html += '</div>';
        elVehicleInfo.innerHTML = html;
        elVehicleSelected.style.display = 'block';
        if (elVehicleWrap) elVehicleWrap.style.display = 'none';
      }

      var brand = currentBrand;
      if (brand) {
        showResultsHeader(brand + ' \u2014 ' + vName, brandLogoUrl(brand));
      } else {
        elResultsName.textContent = vName;
        elResultsLogo.innerHTML = '<i class="las la-car" style="font-size:32px;color:#CC0022"></i>';
      }
      elResultsCount.textContent = 'Loading...';

      if (elFitBadge && elFitBadgeText) {
        var badgeText = 'Vehicle: ' + vName;
        if (brand) badgeText += ' \u00b7 Brand: ' + brand;
        elFitBadgeText.textContent = badgeText;
        elFitBadge.style.display = 'flex';
      }

      showResults();
      loadModels(true);
    }

    // ========================
    // LOAD MODELS (Level 2)
    // ========================
    function loadModels(reset) {
      if (reset) {
        modelOffset = 0;
        models = [];
        elProducts.innerHTML = '';
      }
      elProducts.classList.add('afw-bg__products--models');
      elProductsLoader.style.display = 'flex';
      elMore.style.display = 'none';

      var iw = isAll ? activeType === 'wheels' : isWheels;
      var endpoint = iw ? 'wheels/styles' : 'tires/models';
      var params = { offset: modelOffset };

      if (currentBrand && searchMode !== 'size') params['f-brand'] = currentBrand;
      if (searchMode === 'size' || searchMode === 'vehicle') {
        var brand = getSelectedBrand() || currentBrand;
        if (brand) params['f-brand'] = brand;
      }

      if (searchMode === 'vehicle' && selectedVehicle) {
        if (iw) {
          if (selectedVehicle.LugCount) params['f-lugCount'] = selectedVehicle.LugCount;
          if (selectedVehicle.BoltCircle) params['f-boltCircle'] = selectedVehicle.BoltCircle;
          if (selectedVehicle.Bore) params['f-minBore'] = selectedVehicle.Bore;
        } else {
          var fit = selectedVehicle.Fitments && selectedVehicle.Fitments[0];
          if (fit && fit.RimDiameter) params['f-rimDiameter'] = fit.RimDiameter;
        }
      }

      if (searchMode === 'size') {
        if (iw) {
          if (sizeFilters.diameter) params['f-diameters'] = sizeFilters.diameter;
          if (sizeFilters.width) params['f-widths'] = sizeFilters.width;
          if (sizeFilters.lugCount) params['f-lugCount'] = sizeFilters.lugCount;
          if (sizeFilters.boltCircle) params['f-boltCircle'] = sizeFilters.boltCircle;
          if (sizeFilters.offset) {
            var oMap = {'neg-high':'-44,-43,-42,-41,-40,-39,-38,-37,-36,-35,-34,-33,-32,-31,-30,-29,-28,-27,-26,-25,-24,-23,-22,-21,-20,-19','neg-low':'-18,-17,-16,-15,-14,-13,-12,-11,-10,-9,-8,-7,-6,-5,-4,-3,-2,-1','zero':'0','pos-low':'1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20','pos-med':'21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40','pos-high':'41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60','pos-xhigh':'61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80'};
            if (oMap[sizeFilters.offset]) params['f-offsets'] = oMap[sizeFilters.offset];
          }
        } else {
          if (sizeFilters.diameter) params['f-rimDiameter'] = sizeFilters.diameter;
          if (sizeFilters.sectionWidth) params['f-sectionWidth'] = sizeFilters.sectionWidth;
          if (sizeFilters.aspectRatio) params['f-aspectRatio'] = sizeFilters.aspectRatio;
        }
      }

      if (elProductSearch && elProductSearch.value.trim()) {
        params['f-query'] = elProductSearch.value.trim();
      }

      if (iw) {
        params['i-img0003'] = true;
        params['i-img0001'] = true;
      } else {
        params['i-img'] = true;
        params['i-imgSide'] = true;
      }

      api(endpoint, params, function(err, data) {
        elProductsLoader.style.display = 'none';
        if (err || !data) {
          elResultsCount.textContent = 'Error loading';
          return;
        }

        /* Build a set of already-seen model IDs for client-side dedup */
        var seenIds = {};
        models.forEach(function(m) { seenIds[m.Id] = true; });

        if (iw) {
          wheelImgBase = data.ImgUrlBase || wheelImgBase;
          var rawItems = data.WheelStyles || [];
          /* Dedup: skip any item whose Id we already have */
          var items = rawItems.filter(function(s) { return !seenIds[s.Id]; });
          /* API styles endpoint doesn't truly paginate — disable Load More */
          modelMore = false;
          modelOffset += rawItems.length;
          models = models.concat(items);

          if (models.length === 0) {
            elResultsCount.textContent = 'No wheel models found';
            elProducts.innerHTML = '<div class="afw-bg__no-products"><i class="las la-search"></i><p>No wheel models found. Try broadening your search.</p></div>';
          } else {
            elResultsCount.textContent = models.length + ' models';
            items.forEach(function(style) {
              elProducts.appendChild(buildModelCard(style, true));
            });
          }
        } else {
          tireImgBase = data.ImgUrlBase || tireImgBase;
          var rawItems = data.TireModels || [];
          /* Dedup: skip any item whose Id we already have */
          var items = rawItems.filter(function(m) { return !seenIds[m.Id]; });
          /* API models endpoint doesn't truly paginate — disable Load More */
          modelMore = false;
          modelOffset += rawItems.length;
          models = models.concat(items);

          if (models.length === 0) {
            elResultsCount.textContent = 'No tire models found';
            elProducts.innerHTML = '<div class="afw-bg__no-products"><i class="las la-search"></i><p>No tire models found. Try broadening your search.</p></div>';
          } else {
            elResultsCount.textContent = models.length + ' models';
            items.forEach(function(model) {
              elProducts.appendChild(buildModelCard(model, false));
            });
          }
        }

        if (modelMore) elMore.style.display = 'block';
      });
    }

    function buildModelCard(item, isWheel) {
      var card = document.createElement('div');
      card.className = 'afw-bg__model-card';
      var imgSrc = '';
      var name = '';
      var sub = '';
      if (isWheel) {
        imgSrc = item.Img0003 ? wheelImgBase + item.Img0003 : (item.Img0001 ? wheelImgBase + item.Img0001 : '');
        name = item.Model;
        sub = item.Submodel || '';
        if (item.Material) sub += (sub ? ' \u00b7 ' : '') + item.Material;
        if (item.Structure) sub += (sub ? ' \u00b7 ' : '') + item.Structure;
      } else {
        var tireImg = item.ImgAngle || item.ImgSide1 || item.ImgThumb || item.ImgFront || '';
        imgSrc = tireImg ? tireImgBase + tireImg : '';
        name = item.Model;
        sub = item.Brand || '';
      }

      card.innerHTML =
        '<div class="afw-bg__model-img">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(item.Brand + ' ' + name) + '" loading="lazy">' :
            '<i class="las la-circle-notch" style="font-size:40px;color:#555"></i>') +
        '</div>' +
        '<div class="afw-bg__model-body">' +
          '<div class="afw-bg__model-brand">' + esc(item.Brand) + '</div>' +
          '<div class="afw-bg__model-name">' + esc(name + (sub && isWheel ? ' ' + sub : '')) + '</div>' +
          (sub && !isWheel ? '<div class="afw-bg__model-sub">' + esc(sub) + '</div>' : '') +
          '<div class="afw-bg__model-action">View All Sizes <i class="las la-arrow-right"></i></div>' +
        '</div>';

      card.addEventListener('click', function() {
        clickModel(item, isWheel);
      });
      return card;
    }

    // ========================
    // CLICK MODEL -> Level 3 (Configs)
    // ========================
    function clickModel(item, isWheel) {
      level = 'configs';
      configOffset = 0;
      configMore = false;
      configs = [];
      elProducts.innerHTML = '';

      activeModelName = item.Brand + ' ' + item.Model + (item.Submodel ? ' ' + item.Submodel : '');
      if (isWheel) {
        activeStyleId = item.Id;
        activeModelId = null;
      } else {
        activeModelId = item.Id;
        activeStyleId = null;
      }

      elResultsName.textContent = activeModelName;
      var img = '';
      if (isWheel) {
        img = item.Img0003 ? wheelImgBase + item.Img0003 : '';
      } else {
        var tireImg = item.ImgAngle || item.ImgSide1 || '';
        img = tireImg ? tireImgBase + tireImg : '';
      }
      elResultsLogo.innerHTML = img ? '<img src="' + img + '" alt="' + esc(activeModelName) + '" style="max-width:80px;max-height:80px;object-fit:contain;">' : '';
      elResultsCount.textContent = 'Loading sizes...';

      elBack.innerHTML = '<i class="las la-arrow-left"></i> Back to ' + esc(currentBrand || 'Models');
      elMoreBtn.innerHTML = '<i class="las la-plus-circle"></i> Load More Sizes';

      loadConfigs(true);
    }

    // ========================
    // LOAD CONFIGS (Level 3)
    // ========================
    function loadConfigs(reset) {
      if (reset) {
        configOffset = 0;
        configs = [];
        elProducts.innerHTML = '';
      }
      elProducts.classList.remove('afw-bg__products--models');
      elProductsLoader.style.display = 'flex';
      elMore.style.display = 'none';

      var iw = isAll ? activeType === 'wheels' : isWheels;
      var endpoint = iw ? 'wheels' : 'tires';
      var params = { offset: configOffset };

      if (iw) {
        params['i-img0001'] = true;
        params['i-img0003'] = true;
        params['i-price'] = true;
        params['i-inStock'] = true;
        params['i-specs'] = true;
        params['f-inStock'] = true;
        if (activeStyleId) params['f-styleId'] = activeStyleId;
      } else {
        params['i-img'] = true;
        params['i-imgSide'] = true;
        params['i-imgDefault'] = true;
        params['i-specs'] = true;
        params['i-tags'] = true;
        params['i-price'] = true;
        params['i-inStock'] = true;
        if (activeModelId) params['f-modelId'] = activeModelId;
      }

      if (searchMode === 'vehicle' && selectedVehicle) {
        if (iw) {
          if (selectedVehicle.LugCount) params['f-lugCount'] = selectedVehicle.LugCount;
          if (selectedVehicle.BoltCircle) params['f-boltCircle'] = selectedVehicle.BoltCircle;
        } else {
          var fit = selectedVehicle.Fitments && selectedVehicle.Fitments[0];
          if (fit && fit.RimDiameter) params['f-rimDiameter'] = fit.RimDiameter;
        }
      }
      if (searchMode === 'size') {
        if (iw) {
          if (sizeFilters.diameter) params['f-diameters'] = sizeFilters.diameter;
          if (sizeFilters.width) params['f-widths'] = sizeFilters.width;
          if (sizeFilters.lugCount) params['f-lugCount'] = sizeFilters.lugCount;
          if (sizeFilters.boltCircle) params['f-boltCircle'] = sizeFilters.boltCircle;
          if (sizeFilters.offset) {
            var oMap2 = {'neg-high':'-44,-43,-42,-41,-40,-39,-38,-37,-36,-35,-34,-33,-32,-31,-30,-29,-28,-27,-26,-25,-24,-23,-22,-21,-20,-19','neg-low':'-18,-17,-16,-15,-14,-13,-12,-11,-10,-9,-8,-7,-6,-5,-4,-3,-2,-1','zero':'0','pos-low':'1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20','pos-med':'21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40','pos-high':'41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60','pos-xhigh':'61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80'};
            if (oMap2[sizeFilters.offset]) params['f-offsets'] = oMap2[sizeFilters.offset];
          }
          if (sizeFilters.shortColor) params['f-shortColor'] = sizeFilters.shortColor;
          if (sizeFilters.shortFinish) params['f-shortFinish'] = sizeFilters.shortFinish;
        } else {
          if (sizeFilters.diameter) params['f-rimDiameter'] = sizeFilters.diameter;
          if (sizeFilters.sectionWidth) params['f-sectionWidth'] = sizeFilters.sectionWidth;
          if (sizeFilters.aspectRatio) params['f-aspectRatio'] = sizeFilters.aspectRatio;
          if (sizeFilters.speedRating) params['f-speedRating'] = sizeFilters.speedRating;
        }
      }

      api(endpoint, params, function(err, data) {
        elProductsLoader.style.display = 'none';
        if (err || !data) {
          elResultsCount.textContent = 'Error loading';
          return;
        }

        if (iw) {
          wheelImgBase = data.ImgUrlBase || wheelImgBase;
          var items = data.Wheels || [];
          configMore = !!data.MoreItems;
          configOffset += items.length;
          configs = configs.concat(items);

          if (configs.length === 0) {
            elResultsCount.textContent = 'No configurations found';
            elProducts.innerHTML = '<div class="afw-bg__no-products"><i class="las la-search"></i><p>No wheel configurations found for this model.</p></div>';
          } else {
            elResultsCount.textContent = configs.length + ' configurations' + (configMore ? '+' : '');
            items.forEach(function(w) { elProducts.appendChild(buildWheelCard(w)); });
          }
        } else {
          tireImgBase = data.ImgUrlBase || tireImgBase;
          var items = data.Tires || [];
          configMore = !!data.MoreItems;
          configOffset += items.length;
          configs = configs.concat(items);

          if (configs.length === 0) {
            elResultsCount.textContent = 'No sizes found';
            elProducts.innerHTML = '<div class="afw-bg__no-products"><i class="las la-search"></i><p>No tire sizes found for this model.</p></div>';
          } else {
            elResultsCount.textContent = configs.length + ' sizes' + (configMore ? '+' : '');
            items.forEach(function(t) { elProducts.appendChild(buildTireCard(t)); });
          }
        }

        if (configMore) elMore.style.display = 'block';
      });
    }

    // ========================
    // PRODUCT CARDS
    // ========================
    function buildWheelCard(w) {
      var card = document.createElement('div');
      card.className = 'afw-bg__product';
      var img3 = w.Img0003 ? wheelImgBase + w.Img0003 : '';
      var img1 = w.Img0001 ? wheelImgBase + w.Img0001 : '';
      var imgSrc = img3 || img1;
      var specs = w.Diameter + 'x' + w.Width + '" \u00b7 ' + w.LugCount + 'x' + w.BoltCircle1 + ' \u00b7 ET' + w.Offset;
      if (w.Color) specs += ' \u00b7 ' + w.Color;
      var fullName = w.Brand + ' ' + w.Model + (w.Submodel ? ' ' + w.Submodel : '');

      card.innerHTML =
        '<div class="afw-bg__product-img" data-zoom>' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(fullName) + '" loading="lazy">' :
            '<i class="las la-circle-notch" style="font-size:40px;color:#ddd"></i>') +
          (imgSrc ? '<div class="afw-bg__zoom-hint"><i class="las la-search-plus"></i></div>' : '') +
        '</div>' +
        '<div class="afw-bg__product-body">' +
          '<div class="afw-bg__product-brand">' + esc(w.Brand) + '</div>' +
          '<div class="afw-bg__product-name">' + esc(w.Model + (w.Submodel ? ' ' + w.Submodel : '')) + '</div>' +
          (w.Pn ? '<div class="afw-bg__product-pn">P/N: ' + esc(w.Pn) + '</div>' : '') +
          '<div class="afw-bg__product-specs">' + esc(specs) + '</div>' +
          (w.Price ? '<div class="afw-bg__product-price">$' + w.Price.toLocaleString() + '</div>' : '') +
          (w.InStock !== undefined ?
            '<span class="afw-bg__product-stock ' + (w.InStock ? 'afw-bg__product-stock--in">In Stock' : 'afw-bg__product-stock--out">Call Us') + '</span>' : '') +
        '</div>';

      var zoom = card.querySelector('[data-zoom]');
      if (zoom && imgSrc) {
        zoom.style.cursor = 'zoom-in';
        zoom.addEventListener('click', function() {
          var imgs = [];
          if (img3) imgs.push(img3);
          if (img1 && img1 !== img3) imgs.push(img1);
          openLightbox(imgs.length ? imgs : [imgSrc], fullName,
            (w.Pn ? 'P/N: ' + w.Pn + ' \u00b7 ' : '') + specs + (w.Price ? ' \u00b7 $' + w.Price.toLocaleString() : ''));
        });
      }
      return card;
    }

    function buildTireCard(t) {
      var card = document.createElement('div');
      card.className = 'afw-bg__product';
      var imgAngle = t.ImgAngle ? tireImgBase + t.ImgAngle : '';
      var imgSide = t.ImgSide || t.ImgSide1 ? tireImgBase + (t.ImgSide || t.ImgSide1) : '';
      var imgDefault = t.Img || t.ImgDefault ? tireImgBase + (t.Img || t.ImgDefault) : '';
      var imgSrc = imgAngle || imgSide || imgDefault;
      var specs = t.Size || '';
      if (t.SpeedRating) specs += ' \u00b7 Speed: ' + t.SpeedRating;
      if (t.LoadIndex) specs += ' \u00b7 Load: ' + t.LoadIndex;
      var fullName = t.Brand + ' ' + t.Model;

      card.innerHTML =
        '<div class="afw-bg__product-img" data-zoom>' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(fullName) + '" loading="lazy">' :
            '<i class="las la-circle-notch" style="font-size:40px;color:#ddd"></i>') +
          (imgSrc ? '<div class="afw-bg__zoom-hint"><i class="las la-search-plus"></i></div>' : '') +
        '</div>' +
        '<div class="afw-bg__product-body">' +
          '<div class="afw-bg__product-brand">' + esc(t.Brand) + '</div>' +
          '<div class="afw-bg__product-name">' + esc(t.Model) + '</div>' +
          (t.Pn || t.PartNumber ? '<div class="afw-bg__product-pn">P/N: ' + esc(t.Pn || t.PartNumber) + '</div>' : '') +
          '<div class="afw-bg__product-specs">' + esc(specs) + '</div>' +
          (t.Price ? '<div class="afw-bg__product-price">$' + t.Price.toLocaleString() + '</div>' : '') +
          (t.InStock !== undefined ?
            '<span class="afw-bg__product-stock ' + (t.InStock ? 'afw-bg__product-stock--in">In Stock' : 'afw-bg__product-stock--out">Call Us') + '</span>' : '') +
        '</div>';

      var zoom = card.querySelector('[data-zoom]');
      if (zoom && imgSrc) {
        zoom.style.cursor = 'zoom-in';
        zoom.addEventListener('click', function() {
          var imgs = [];
          if (imgAngle) imgs.push(imgAngle);
          if (imgSide) imgs.push(imgSide);
          if (imgDefault && imgDefault !== imgAngle) imgs.push(imgDefault);
          var pn = t.Pn || t.PartNumber;
          openLightbox(imgs.length ? imgs : [imgSrc], fullName,
            (pn ? 'P/N: ' + pn + ' \u00b7 ' : '') + specs + (t.Price ? ' \u00b7 $' + t.Price.toLocaleString() : ''));
        });
      }
      return card;
    }

    // ========================
    // NAVIGATION
    // ========================
    function showResultsHeader(name, logoUrl) {
      elResultsName.textContent = name;
      var cb = clearbitUrl(name);
      elResultsLogo.innerHTML = '<img src="' + logoUrl + '" alt="' + esc(name) + '"' +
        (cb ? ' data-cb="' + cb + '" onerror="if(!this.dataset.tried&&this.dataset.cb){this.dataset.tried=1;this.src=this.dataset.cb;}else{this.style.display=\'none\';}"' : '') + '>';
    }

    function showResults() {
      var toolbar = elGrid.parentElement.querySelector('.afw-bg__toolbar');
      if (toolbar) toolbar.style.display = 'none';
      elGrid.style.display = 'none';
      if (elCount) elCount.style.display = 'none';
      elEmpty.style.display = 'none';
      elResults.classList.add('is--visible');
      elMore.style.display = 'none';
      elProducts.innerHTML = '';

      if (level === 'models') {
        elBack.innerHTML = '<i class="las la-arrow-left"></i> Back to All Brands';
        elMoreBtn.innerHTML = '<i class="las la-plus-circle"></i> Load More Models';
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function hideResults() {
      elResults.classList.remove('is--visible');
      var toolbar = elGrid.parentElement.querySelector('.afw-bg__toolbar');
      if (toolbar) toolbar.style.display = '';
      elGrid.style.display = '';
      if (elCount) elCount.style.display = '';
      window.scrollTo({ top: savedScrollY, behavior: 'smooth' });
    }

    function goBack() {
      if (level === 'configs') {
        level = 'models';
        elProducts.innerHTML = '';
        configOffset = 0;
        configs = [];

        if (currentBrand) {
          showResultsHeader(currentBrand, brandLogoUrl(currentBrand));
        }
        elResultsCount.textContent = models.length + ' models' + (modelMore ? '+' : '');
        elBack.innerHTML = '<i class="las la-arrow-left"></i> Back to All Brands';
        elMoreBtn.innerHTML = '<i class="las la-plus-circle"></i> Load More Models';

        var iw = isAll ? activeType === 'wheels' : isWheels;
        models.forEach(function(m) {
          elProducts.appendChild(buildModelCard(m, iw));
        });
        if (modelMore) elMore.style.display = 'block';
        else elMore.style.display = 'none';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (level === 'models') {
        if (searchMode) {
          clearAll();
        } else {
          level = 'brands';
          currentBrand = null;
          hideResults();
        }
      }
    }

    function clearAll() {
      selectedVehicle = null;
      searchMode = null;
      currentBrand = null;
      sizeFilters = {};
      level = 'brands';
      models = [];
      configs = [];
      modelOffset = 0;
      configOffset = 0;

      if (elVehicleSelected) elVehicleSelected.style.display = 'none';
      if (elVehicleWrap) elVehicleWrap.style.display = '';
      if (elVehicleInput) elVehicleInput.value = '';
      if (elSizeFilters) elSizeFilters.querySelectorAll('select').forEach(function(s) { s.value = ''; });

      ['afw-bg-man-dia','afw-bg-man-width','afw-bg-man-lug','afw-bg-man-bolt','afw-bg-man-offset',
       'afw-bg-man-rim','afw-bg-man-sw','afw-bg-man-ar'].forEach(function(id) {
        var el = $(id);
        if (el) el.value = '';
      });

      if (elSizeBtn) elSizeBtn.disabled = true;
      if (elSizeClear) elSizeClear.style.display = 'none';
      if (elBrandSelect) elBrandSelect.value = '';
      if (elFitBadge) elFitBadge.style.display = 'none';
      if (elProductSearch) elProductSearch.value = '';

      hideResults();
    }

    // ========================
    // VEHICLE SEARCH
    // ========================
    function setupVehicleSearch() {
      if (!elVehicleInput) return;
      var debounce;
      elVehicleInput.addEventListener('input', function() {
        clearTimeout(debounce);
        var q = elVehicleInput.value.trim();
        if (q.length < 3) {
          elVehicleResults.innerHTML = '';
          elVehicleResults.style.display = 'none';
          return;
        }
        debounce = setTimeout(function() { searchVehicles(q); }, 350);
      });
      document.addEventListener('click', function(e) {
        if (elVehicleResults && !elVehicleResults.contains(e.target) && e.target !== elVehicleInput) {
          elVehicleResults.style.display = 'none';
        }
      });
    }

    function searchVehicles(query) {
      elVehicleResults.innerHTML = '<div class="afw-bg__vr-loading"><div class="afw-bg__spinner" style="width:16px;height:16px;border-width:2px"></div> Searching...</div>';
      elVehicleResults.style.display = 'block';
      api('vehicles', { 'f-query': query, 'i-fitments': true, 's-year': 'desc' }, function(err, data) {
        if (err || !data || !data.Vehicles || data.Vehicles.length === 0) {
          elVehicleResults.innerHTML = '<div class="afw-bg__vr-empty">No vehicles found. Try "2024 Ford F-150"</div>';
          return;
        }
        elVehicleResults.innerHTML = '';
        data.Vehicles.slice(0, 10).forEach(function(v) {
          var item = document.createElement('div');
          item.className = 'afw-bg__vr-item';
          var name = v.Year + ' ' + v.Make + ' ' + v.Model;
          if (v.Submodel) name += ' ' + v.Submodel;
          var fit = v.Fitments && v.Fitments[0];
          var fitInfo = '';
          if (v.LugCount && v.BoltCircle) fitInfo = v.LugCount + 'x' + v.BoltCircle + 'mm';
          if (fit && fit.TireSize) fitInfo += (fitInfo ? ' \u00b7 ' : '') + fit.TireSize;
          item.innerHTML =
            '<div class="afw-bg__vr-name">' + esc(name) + '</div>' +
            (fitInfo ? '<div class="afw-bg__vr-fit">' + esc(fitInfo) + '</div>' : '');
          item.addEventListener('click', function() {
            startVehicleSearch(v);
          });
          elVehicleResults.appendChild(item);
        });
      });
    }

    // ========================
    // LIGHTBOX
    // ========================
    function openLightbox(images, title, details) {
      if (!elLightbox || !elLightboxImg) return;
      lbImages = images;
      lbIndex = 0;
      elLightboxImg.src = lbImages[0];
      elLightboxImg.alt = title;
      var html = '<strong>' + esc(title) + '</strong>';
      if (details) html += '<span>' + esc(details) + '</span>';
      if (lbImages.length > 1) html += '<span class="afw-bg__lightbox-nav">1 / ' + lbImages.length + ' \u2014 click image for next</span>';
      elLightboxInfo.innerHTML = html;
      elLightbox.classList.add('is--open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!elLightbox) return;
      elLightbox.classList.remove('is--open');
      document.body.style.overflow = '';
      elLightboxImg.src = '';
    }

    // ========================
    // EVENT BINDINGS
    // ========================
    elSearch.addEventListener('input', filterBrandGrid);

    elAlpha.addEventListener('click', function(e) {
      var btn = e.target.closest('.afw-bg__alpha-btn');
      if (!btn) return;
      alphaFilter = btn.getAttribute('data-letter');
      elAlpha.querySelectorAll('.afw-bg__alpha-btn').forEach(function(b) {
        b.classList.toggle('is--active', b === btn);
      });
      filterBrandGrid();
    });

    if (elBrandSelect) elBrandSelect.addEventListener('change', onSizeChange);

    if (elSizeBtn) {
      elSizeBtn.addEventListener('click', function() {
        startSizeSearch();
      });
    }

    setupVehicleSearch();
    bindManualInputs();

    if (elVehicleClear) elVehicleClear.addEventListener('click', clearAll);
    if (elFitBadgeClear) elFitBadgeClear.addEventListener('click', clearAll);
    if (elSizeClear) elSizeClear.addEventListener('click', clearAll);

    elBack.addEventListener('click', goBack);

    elMoreBtn.addEventListener('click', function() {
      if (level === 'models') loadModels(false);
      else if (level === 'configs') loadConfigs(false);
    });

    if (elProductSearch) {
      var psDebounce;
      elProductSearch.addEventListener('input', function() {
        clearTimeout(psDebounce);
        psDebounce = setTimeout(function() {
          if (level === 'models') loadModels(true);
          else if (level === 'configs') loadConfigs(true);
        }, 400);
      });
    }

    if (elTypeToggle) {
      elTypeToggle.addEventListener('click', function(e) {
        var btn = e.target.closest('.afw-bg__toggle-btn');
        if (!btn) return;
        var t = btn.getAttribute('data-type');
        if (t === activeType) return;
        activeType = t;
        elTypeToggle.querySelectorAll('.afw-bg__toggle-btn').forEach(function(b) {
          b.classList.toggle('is--active', b === btn);
        });
        if (level === 'models') loadModels(true);
        else if (level === 'configs') {
          level = 'models';
          loadModels(true);
        }
      });
    }

    if (elLightboxClose) elLightboxClose.addEventListener('click', closeLightbox);
    if (elLightbox) {
      elLightbox.addEventListener('click', function(e) { if (e.target === elLightbox) closeLightbox(); });
      if (elLightboxImg) {
        elLightboxImg.style.cursor = 'pointer';
        elLightboxImg.addEventListener('click', function(e) {
          e.stopPropagation();
          if (lbImages.length <= 1) return;
          lbIndex = (lbIndex + 1) % lbImages.length;
          elLightboxImg.src = lbImages[lbIndex];
          var nav = elLightboxInfo.querySelector('.afw-bg__lightbox-nav');
          if (nav) nav.textContent = (lbIndex + 1) + ' / ' + lbImages.length + ' \u2014 click image for next';
        });
      }
      document.addEventListener('keydown', function(e) {
        if (!elLightbox.classList.contains('is--open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight' && lbImages.length > 1) {
          lbIndex = (lbIndex + 1) % lbImages.length;
          elLightboxImg.src = lbImages[lbIndex];
        }
        if (e.key === 'ArrowLeft' && lbImages.length > 1) {
          lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length;
          elLightboxImg.src = lbImages[lbIndex];
        }
      });
    }
  }

  // ========================
  // BOOT
  // ========================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
